module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "contents"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/fm002#fm002"
    }
  }, [_vm._v("Foreword by Peter Senge")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introduction"
    }
  }, [_vm._v("Introduction: The Problem with Tough Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part001#part001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUGH")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROBLEMS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt01_ch01#pt01_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“There Is Only One Right Answer”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt01_ch02#pt01_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seeing the World")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt01_ch03#pt01_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Miraculous Option")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part002#part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALKING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt02_ch01#pt02_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Being Stuck")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt02_ch02#pt02_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dictating")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt02_ch03#pt02_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talking Politely")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt02_ch04#pt02_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speaking Up")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt02_ch05#pt02_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Only Talking")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part003#part003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III: L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTENING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt03_ch01#pt03_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Openness")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt03_ch02#pt03_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reflectiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt03_ch03#pt03_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Empathy")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part004#part004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" IV: C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATING")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EALITIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt04_ch01#pt04_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cracking Through the Egg Shell")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt04_ch02#pt04_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closed Fist, Open Palm")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt04_ch03#pt04_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wound That Wants to Be Whole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/conclusion#conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: An Open Way")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bibliography#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/author#author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0